import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(consent-manger)/[locale]/(lagacy-footer)/advokati/[id]/LawyerProfileView.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfileTour"] */ "/app/src/elements/tour/useProfileTour.tsx");
